import React from 'react';
import { Configure as InstantSearchConfigure } from 'react-instantsearch';

interface ConfigureProps {
  hitsPerPage?: number;
  filters?: string;
}

/**
 * Wrapper component for react-instantsearch's Configure widget
 * Sets default search configuration parameters like results per page and filters
 *
 * Note: This component renders nothing to the DOM, it only configures the search
 */
export const Configure: React.FC<ConfigureProps> = ({ hitsPerPage = 12, filters }) => {
  return (
    <InstantSearchConfigure
      hitsPerPage={hitsPerPage}
      filters={filters}
      typoTolerance={true}
      minWordSizefor1Typo={3}
      minWordSizefor2Typos={7}
      removeWordsIfNoResults="lastWords"
    />
  );
};
